import { render } from "./ReturnOrdersListPage.vue?vue&type=template&id=532dd55e&ts=true"
import script from "./ReturnOrdersListPage.vue?vue&type=script&lang=ts"
export * from "./ReturnOrdersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__